/**
 * @param {(string | false | null | undefined)[]} classes
 * @returns {string}
 */
export default function cn(classes) {
  return classes
    .filter(Boolean)
    .join(' ');
}
